import {
  bffCrmAppointmentsReviewConcerns,
  BffCrmAppointmentsReviewConcernsRetrieveResponse,
} from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'

const getSymptomVisitType = async ({
  symptom_ids,
  other_symptoms,
  patient_id,
  selected_appointment_type_group_id,
}: {
  symptom_ids: number[]
  other_symptoms?: string
  patient_id: number
  selected_appointment_type_group_id?: number
}): Promise<BffCrmAppointmentsReviewConcernsRetrieveResponse> => {
  const response = await bffCrmAppointmentsReviewConcerns.retrieve({
    params: {
      symptom_ids: symptom_ids.join(','),
      other_symptoms,
      patient_id,
      selected_appointment_type_group_id,
    },
  })
  return response.data
}

// The group id scopes triage to the appointment type group the user picked, so
// the resolver prefers a type inside that group. The legacy wizard has no
// groups and omits it. `enabled` lets the booking wizard prefetch triage while
// concerns are still being picked, without firing on an empty selection.
// The wizard's book step gates on this read, so a genuine failure must reach
// isError quickly: one retry instead of the default three-retry backoff.
export const useGetSymptomVisitType = ({
  symptom_ids,
  other_symptoms,
  patient_id,
  selected_appointment_type_group_id,
  enabled = true,
}: {
  symptom_ids: number[]
  other_symptoms?: string
  patient_id: number
  selected_appointment_type_group_id?: number
  enabled?: boolean
}) => {
  const {
    data,
    isPending: isLoading,
    isError,
  } = useQuery(
    [
      'symptomVisitType',
      symptom_ids,
      other_symptoms,
      patient_id,
      selected_appointment_type_group_id,
    ],
    () =>
      getSymptomVisitType({
        symptom_ids,
        other_symptoms,
        patient_id,
        selected_appointment_type_group_id,
      }),
    { enabled, retry: 1 },
  )

  return { result: data ?? undefined, isLoading, isError }
}
